import React, { Component } from "react";
import cx from "classnames";
import Link from "gatsby-link";
import Navbar from "../molecules/Navbar";
import Hamburger from "../molecules/Hamburger";
import logo from "../img/logo.svg";
import { Helmet } from "react-helmet";

const links = [
  {
    to: "/cases/",
    text: "Our work"
  },
  {
    to: "/trainings/",
    text: "Trainings"
  },
  {
    to: "/blog/",
    text: "Blog"
  },
  {
    to: "/#contactus",
    text: "Contact us"
  }
];

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.state = { isBig: true };
    this.lastScroll = 0;
  }

  componentDidMount() {
    typeof window !== "undefined" &&
      window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    const scrollTop = event.srcElement.body.scrollTop;
    const direction = scrollTop > this.lastScroll ? "down" : "up";
    this.lastScroll = scrollTop;

    this.setState({
      isBig: direction === "up" || scrollTop < 60
    });
  }

  render() {
    return (
      <header className={cx("header", { "is-small": !this.state.isBig })}>
        <Helmet>
          <title>Limenius - We build software.</title>
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@limenius" />
          <meta name="twitter:title" content="Limenius - We build software." />
          <meta
            name="twitter:description"
            content="Digital solutions partner."
          />
          <meta
            name="twitter:image"
            content="https://limenius.com/social/logo.png"
          />

          <meta property="og:title" content="Limenius - We build software." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content=" https://limenius.com" />
          <meta
            property="og:image"
            content="https://limenius.com/social/logo.png"
          />
          <meta property="og:site_name" content="Limenius" />
          <meta
            property="og:description"
            content="Digital solutions partner."
          />
        </Helmet>
        <div className="container">
          <div className="c-header--wrapper">
            <Link to="/">
              <img alt="limenius logo" width="157" src={logo} />
            </Link>
            <div className="c-header--nav">
              <div className="u-max-sm">
                <Hamburger links={links} />
              </div>
              <div className="u-min-sm">
                <Navbar links={links} />
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/organisms/Header.js